import { Controller } from "@hotwired/stimulus"

// Manages the mobile sticky footer visibility and count badges.
export default class extends Controller {
  static targets = ["quoteBadge", "cartBadge"]
  static values = {
    quoteCount: Number,
    cartCount: Number
  }

  connect() {
    this.handleCountChange = this.handleCountChange.bind(this)
    window.addEventListener("top-notice:count-changed", this.handleCountChange)
    this.refreshUI()
  }

  disconnect() {
    window.removeEventListener("top-notice:count-changed", this.handleCountChange)
  }

  quoteCountValueChanged() {
    this.refreshUI()
  }

  cartCountValueChanged() {
    this.refreshUI()
  }

  handleCountChange(event) {
    const { type, count } = event.detail || {}
    if (type === "cart") {
      this.cartCountValue = count
    } else if (type === "quote") {
      this.quoteCountValue = count
    }
  }

  refreshUI() {
    this.toggleVisibility()
    if (this.hasQuoteBadgeTarget) {
      this.updateBadge(this.quoteBadgeTarget, this.quoteCountValue)
    }
    if (this.hasCartBadgeTarget) {
      this.updateBadge(this.cartBadgeTarget, this.cartCountValue)
    }
  }

  toggleVisibility() {
    const hasCounts =
      (Number(this.cartCountValue) || 0) > 0 ||
      (Number(this.quoteCountValue) || 0) > 0
    this.element.classList.toggle("hidden", !hasCounts)
  }

  updateBadge(target, count) {
    if (!target) return

    const safeCount = Number(count) || 0
    target.textContent = safeCount
    target.classList.toggle("hidden", safeCount <= 0)
  }
}
